import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { UserPermissionType } from '@gasbi/shared/common/providers/PermissionProvider/types';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_CLIENT_URL + '/users',
  }),
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({ url: `/permissions` }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
